var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import axios from "axios";
import selectn from "selectn";
import backend from "../utils/backend";
import { GET_STORY, GET_STORY_SUCCESS, GET_STORY_UPDATE, GET_STORY_ERROR, GET_STORIES_STREAM, GET_STORIES_STREAM_SUCCESS, GET_STORIES_STREAM_UPDATE, GET_STORIES_STREAM_ERROR, RESET_STORIES_STREAM_ERROR, SET_STORY_STREAM } from "../constants/actionTypes";

import { BACKEND_ROOT } from "../config/constants";

export var getStoriesStream = function getStoriesStream(params) {
  var appendResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function (dispatch) {
    if (!appendResults) {
      dispatch({
        type: GET_STORIES_STREAM
      });
    }
    return backend.request({
      method: "GET",
      url: "/stream/",
      params: params
    }).then(function (response) {
      if (!appendResults && !selectn("data.results.length", response)) {
        return dispatch({
          type: GET_STORIES_STREAM_ERROR,
          payload: {
            handleError: true,
            error: { response: { status: 404, message: "API returned empty results" } },
            params: params
          }
        });
      }
      return dispatch({
        type: appendResults ? GET_STORIES_STREAM_UPDATE : GET_STORIES_STREAM_SUCCESS,
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: GET_STORIES_STREAM_ERROR,
        payload: {
          handleError: true,
          error: err,
          params: params
        }
      });
    });
  };
};

export var loadNextStory = function loadNextStory(params, position, alreadyLoadedStories) {
  return function (dispatch) {
    dispatch({
      type: GET_STORY
    });

    return backend.request({
      method: "GET",
      url: "/stream/",
      params: params
    }).then(function (response) {
      var payload = void 0;
      var results = response.data.results;

      for (var i = 0; i < results.length; i++) {
        if (!(alreadyLoadedStories || []).includes(results[i].id)) {
          payload = results[i];
          break;
        }
      }

      if (!payload) {
        return dispatch(loadNextStory(_extends({}, params, { page: (params.page || 1) + 1 }), position, alreadyLoadedStories));
      }

      return dispatch({
        type: GET_STORY_UPDATE,
        payload: payload,
        position: position
      });
    }).catch(function (err) {
      dispatch({
        type: GET_STORY_ERROR,
        payload: err
      });
    });
  };
};

export var loadStory = function loadStory(params, position) {
  var handleError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return function (dispatch) {
    dispatch({
      type: GET_STORY
    });

    return backend.request({
      method: "GET",
      url: "/stream/",
      params: params || {}
    }).then(function (response) {
      return dispatch({
        type: position ? GET_STORY_UPDATE : GET_STORY_SUCCESS,
        payload: response.data.results[0],
        position: position
      });
    }).catch(function (err) {
      return dispatch({
        type: GET_STORY_ERROR,
        payload: {
          handleError: handleError,
          error: err,
          params: params
        }
      });
    });
  };
};

export var loadRevision = function loadRevision(storyId, revision, accessToken, position) {
  return function (dispatch) {
    dispatch({
      type: GET_STORY
    });

    return axios.request({
      method: "GET",
      url: BACKEND_ROOT + "/api/content/" + storyId + "/revisions/" + revision + "/",
      headers: {
        "Authorization": "Bearer " + accessToken
      }
    }).then(function (response) {
      var payload = selectn("data.results[0]", response) || (Array.isArray(response.data) ? selectn("data[0]", response) : response.data) || null;
      return dispatch({
        type: position ? GET_STORY_UPDATE : GET_STORY_SUCCESS,
        payload: payload,
        position: position
      });
    }).catch(function (err) {
      dispatch({
        type: GET_STORY_ERROR,
        payload: err
      });
    });
  };
};

export var loadLatest = function loadLatest(storyId, accessToken, position) {
  return function (dispatch) {
    dispatch({
      type: GET_STORY
    });

    return axios.request({
      method: "GET",
      url: BACKEND_ROOT + "/api/content/" + storyId + "/",
      headers: {
        "Authorization": "Bearer " + accessToken
      }
    }).then(function (response) {
      return dispatch({
        type: position ? GET_STORY_UPDATE : GET_STORY_SUCCESS,
        payload: "results" in response.data ? response.data.results[0] : response.data,
        position: position
      });
    }).catch(function (err) {
      dispatch({
        type: GET_STORY_ERROR,
        payload: err
      });
    });
  };
};

export var addStory = function addStory(story) {
  return function (dispatch) {
    return dispatch({
      type: GET_STORY_UPDATE,
      payload: story
    });
  };
};

export var removeStory = function removeStory() {
  return function (dispatch) {
    return dispatch({
      type: GET_STORY_SUCCESS,
      payload: null
    });
  };
};

export var resetStoriesStreamError = function resetStoriesStreamError() {
  return function (dispatch) {
    return dispatch({
      type: RESET_STORIES_STREAM_ERROR
    });
  };
};

export var setStoryStream = function setStoryStream(stories) {
  return function (dispatch) {
    dispatch({
      type: SET_STORY_STREAM,
      payload: stories
    });
  };
};


// WEBPACK FOOTER //
// ./src/actions/storiesStream.js